// @flow

import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import { GetClientStaffGroups } from "@modules/shared/constants/actions";
import { transformFilters, OPERATORS } from "@transformers/request";

type StaffGroupsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetClientStaffGroups({
  payload,
}: Action<StaffGroupsRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId) {
    throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
  }

  try {
    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${payload.clientId}/staff-group`,
      {
        params: {
          search: transformFilters(
            {
              isEnabled: true,
            },
            {
              is_enabled: OPERATORS.EQUALS,
            },
          ),
          limit: 100,
        },
      },
    );

    yield put(actionCreators.GetClientStaffGroupsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetClientStaffGroupsError(e.response));
  }
}

export function* StaffGroupsSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetClientStaffGroups, onGetClientStaffGroups)]);
}

export default StaffGroupsSagas;
